import { CostCenterData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const costCentersApi = apiResource<CostCenterData>('cost-centers');
